var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorld(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_477",
    "data-name": "Group 477",
    transform: "translate(-1209 -11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "language_1_",
    "data-name": "language (1)",
    d: "M12.383,0A12.383,12.383,0,1,0,24.765,12.383,12.383,12.383,0,0,0,12.383,0ZM23.092,16.721l-3.522.608a18.478,18.478,0,0,0,.648-4.533H23.93a11.48,11.48,0,0,1-.838,3.925ZM.836,12.8H4.547a18.479,18.479,0,0,0,.648,4.533l-3.522-.608A11.481,11.481,0,0,1,.836,12.8Zm.838-4.751,3.522-.608a18.479,18.479,0,0,0-.648,4.533H.836a11.481,11.481,0,0,1,.838-3.925ZM12.8,6.627a28.4,28.4,0,0,1,4.425.4l1.457.251a17.717,17.717,0,0,1,.716,4.687H12.8Zm4.566-.41A29.257,29.257,0,0,0,12.8,5.8V.849c2.366.227,4.422,2.394,5.587,5.547ZM11.97,5.8A29.252,29.252,0,0,0,7.4,6.218l-1.022.177C7.548,3.241,9.6,1.073,11.97.847ZM7.545,7.031a28.388,28.388,0,0,1,4.424-.4V11.97h-6.6a17.718,17.718,0,0,1,.716-4.687ZM5.372,12.8h6.6v5.343a28.4,28.4,0,0,1-4.425-.4l-1.457-.251A17.717,17.717,0,0,1,5.372,12.8ZM7.4,18.548a29.356,29.356,0,0,0,4.566.418v4.953c-2.366-.228-4.422-2.394-5.587-5.547Zm5.391.418a29.353,29.353,0,0,0,4.565-.418l1.022-.177c-1.165,3.154-3.22,5.321-5.587,5.548Zm4.424-1.232a28.388,28.388,0,0,1-4.424.4V12.8h6.6a17.717,17.717,0,0,1-.716,4.687Zm3-5.764a18.479,18.479,0,0,0-.648-4.533l3.522.608a11.481,11.481,0,0,1,.838,3.925Zm2.456-4.835L19.3,6.552a11.382,11.382,0,0,0-3.284-5.139,11.612,11.612,0,0,1,6.66,5.721ZM8.75,1.414A11.382,11.382,0,0,0,5.467,6.552l-3.376.582A11.612,11.612,0,0,1,8.75,1.414ZM2.091,17.63l3.376.582A11.382,11.382,0,0,0,8.75,23.352a11.612,11.612,0,0,1-6.66-5.721Zm13.924,5.721A11.382,11.382,0,0,0,19.3,18.213l3.376-.582a11.612,11.612,0,0,1-6.66,5.721Zm0,0",
    transform: "translate(1221 23)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1181",
    "data-name": "Rectangle 1181",
    width: 48,
    height: 48,
    transform: "translate(1209 11)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorld);
export default __webpack_public_path__ + "static/media/world.c7b330223afaf3f15169b3fc31fa6c42.svg";
export { ForwardRef as ReactComponent };